import { LoadingButton } from "@mui/lab";
import { Box, FormControl, Grid, InputLabel, TextField } from "@mui/material";
import axios, { AxiosInstance } from "axios";
import React, { FC, Fragment, useEffect, useState } from "react";
import Cookies from "universal-cookie";
import CheckAttr from "../../../utils/CheckAttr";
import { SecondNiveau } from "../../content/parametrage/Article/Article";
import { useStyles } from "../styles";
import SaveIcon from "@mui/icons-material/Save";
import { checkViaCodeArticle } from "../../../utils/utils";
import { codeArticleNotToDisable } from "../../../constants/Constants";
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { loggoutUser } from "../../../redux/actions/logginUser";

interface InputValidation {
  dateDebut: boolean;
  TarifHeure: boolean;
  TarifActe: boolean;
  coutA: boolean;
  dateCout: boolean;
}

const resetInpuValidation: InputValidation = {
  dateDebut: false,
  TarifActe: false,
  TarifHeure: false,
  coutA: false,
  dateCout: false,
};

interface UpdateTarifFormProps {
  articleSecond: SecondNiveau;
  onClose: () => void;
  openModal: boolean;
  reloadList: () => void;
}

const DuplicateTarifByArticle: FC<UpdateTarifFormProps> = ({
  articleSecond,
  onClose,
  openModal,
  reloadList,
}) => {
  const classes = useStyles();
  const [dateDebut, setDateDebut] = useState<Date | undefined>(
    articleSecond?.tar_date_debut
  );
  const [tarifheure, setTarifheure] = useState<string | undefined>(
    articleSecond?.tarifheure ? parseFloat(articleSecond?.tarifheure as string).toFixed(2) : ""
  );
  const [tarifActse, setTarifActe] = useState<string | undefined>(
    articleSecond?.tarifacte ? parseFloat(articleSecond?.tarifacte as string).toFixed(2) : ""
  );

  const codeArticle = articleSecond?.code_article_libelle;
  const disableHeureInput = (): boolean => {
    if (
      CheckAttr(tarifActse) ||
      checkViaCodeArticle(codeArticleNotToDisable, ["A", "a"], codeArticle)
    ) {
      return true;
    }

    return false;
  };
  const disableActeInput = (): boolean => {
    if (
      CheckAttr(tarifheure) ||
      checkViaCodeArticle(codeArticleNotToDisable, ["H", "h"], codeArticle)
    ) {
      return true;
    }

    return false;
  };

  const [errorInput, setErrorInput] =
    useState<InputValidation>(resetInpuValidation);

  const [dateDebutParent, setDateDebutParent] = useState<string>();

  const cookies = new Cookies();
  const token: string = cookies.get("jwt");
  const [isClickSave, setIsClickSave] = useState<boolean>(false);

  const urlBaseApi = process.env.REACT_APP_BASE_API_URL as string;
  const http: AxiosInstance = axios.create({
    baseURL: urlBaseApi,
    // timeout: 1000,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  
  const navigate = useNavigate();
  const dispatch = useDispatch();


 // Add global response interceptor
  http.interceptors.response.use(
      (response) => {
      // Modify response data here, if needed
      return response;
      },
      (error) => {
          console.log(error.message);
          if(error.message ==="Request failed with status code 401"){
              // Remove the redux store
              dispatch(loggoutUser());

              // Remove token in navigator cookies
              cookies.remove('jwt', { path: '/' });

              navigate("/sign-in");
          }
          return Promise.reject(error);
      }
  );



  const isValidate = (): boolean => {
    if (
      !CheckAttr(dateDebut) ||
      (!CheckAttr(tarifActse) &&
      !CheckAttr(tarifheure))
    ) {
      if (!CheckAttr(tarifActse)) {
        setErrorInput((prev: InputValidation) => ({
          ...prev,
          TarifActe: true,
        }));
      }

      if (!CheckAttr(tarifheure)) {
        setErrorInput((prev: InputValidation) => ({
          ...prev,
          TarifHeure: true,
        }));
      }

      if (!CheckAttr(dateDebut)) {
        setErrorInput((prev: InputValidation) => ({
          ...prev,
          dateDebut: true,
        }));
      }
      return false;
    }
    return true;
  };

  const handleSave = () => {
    if (isValidate()) {
      setIsClickSave(true);
      const data = {
        id: articleSecond?.tarif_id,
        date_debut: dateDebut,
        tarif_acte: tarifActse,
        tarif_heure: tarifheure,
      };
      http
        .post("tarification/duplicate", data)
        .then(() => {
          onClose();
          reloadList();
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          setIsClickSave(false);
          // setDialogLoading(false);
        });
    }
  };

  useEffect(() => {
    // get DateFin
    http
      .get(
        `article/get-date-debut-parent-for/Tarification/${articleSecond?.tarif_id}`
      )
      .then((res) => {
        setDateDebutParent(res.data);
      }).catch(error => {
        console.log(error);
    });
  }, []);
  return (
    <Fragment>
      <Grid container spacing={2} columns={{ xs: 6, sm: 12, md: 4 }}>
        <Grid item xs={6} sm={6} md={2}>
          <FormControl
            variant="outlined"
            className={classes.formControl}
            sx={{ marginLeft: 1, marginTop: 1 }}
          >
            <TextField
              name="libelleClient"
              label="Pays"
              color="warning"
              fullWidth
              // error={errorInput.libelle}
              disabled
              autoComplete="off"
              value={articleSecond?.pays_libelle}
              InputLabelProps={{
                shrink: CheckAttr(articleSecond?.libelle),
              }}
            />
          </FormControl>
          <FormControl
            variant="outlined"
            className={classes.formControl}
            sx={{ marginLeft: 1, marginTop: 1 }}
          >
            <TextField
              name="libelleClient"
              label="Bu"
              color="warning"
              fullWidth
              // error={errorInput.libelle}
              disabled
              autoComplete="off"
              value={articleSecond?.bu_libelle}
              InputLabelProps={{
                shrink: CheckAttr(articleSecond?.libelle),
              }}
            />
          </FormControl>
          <FormControl
            variant="outlined"
            className={classes.formControl}
            sx={{ marginLeft: 1, marginTop: 1 }}
          >
            <TextField
              name="coutactivite"
              label="Tarif Heure"
              color="warning"
              fullWidth
              autoComplete="off"
              type="number"
              placeholder="Ex: 2.02"
              inputProps={{
                step: 0.01,
                lang: "en-US",
              }}
              error={errorInput.TarifHeure}
              disabled={disableHeureInput()}
              value={tarifheure}
              onChange={(e) => setTarifheure(e.target.value)}
              InputLabelProps={
                {
                  //shrink: CheckAttr(coutToUpdate),
                }
              }
            />
          </FormControl>
          <FormControl
            variant="outlined"
            className={classes.formControl}
            sx={{ marginTop: 1 }}
          >
            <TextField
              name="date_debut"
              label="Date debut"
              type="date"
              color="warning"
              fullWidth
              error={errorInput.dateDebut}
              value={dateDebut}
              inputProps={{
                // min: minDate()
                min: dateDebutParent,
              }}
              onChange={(e: any) => setDateDebut(e.target.value)}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </FormControl>
        </Grid>

        <Grid item xs={6} sm={6} md={2}>
          <FormControl
            variant="outlined"
            className={classes.formControl}
            sx={{ marginLeft: 1, marginTop: 1 }}
          >
            <TextField
              name="libelleClient"
              label="Article"
              color="warning"
              fullWidth
              // error={errorInput.libelle}
              disabled
              autoComplete="off"
              value={articleSecond?.libelle}
              InputLabelProps={{
                shrink: CheckAttr(articleSecond?.libelle),
              }}
            />
          </FormControl>
          <FormControl
            variant="outlined"
            className={classes.formControl}
            sx={{ marginLeft: 1, marginTop: 1 }}
          >
            <TextField
              name="libelleClient"
              label="Code Article"
              color="warning"
              fullWidth
              // error={errorInput.libelle}
              disabled
              autoComplete="off"
              value={articleSecond?.code_article_libelle}
              InputLabelProps={{
                shrink: CheckAttr(articleSecond?.libelle),
              }}
            />
          </FormControl>
          <FormControl
            variant="outlined"
            className={classes.formControl}
            sx={{ marginLeft: 1, marginTop: 1 }}
          >
            <TextField
              name="coutactivite"
              label="Tarif Acte"
              color="warning"
              fullWidth
              autoComplete="off"
              type="number"
              placeholder="Ex: 2.02"
              inputProps={{
                step: 0.01,
                lang: "en-US",
              }}
              error={errorInput.TarifActe}
              value={tarifActse}
              onChange={(e) => setTarifActe(e.target.value)}
              InputLabelProps={
                {
                  //shrink: CheckAttr(coutToUpdate),
                }
              }
              disabled={disableActeInput()}
            />
          </FormControl>
        </Grid>
      </Grid>
      <Box display="flex" justifyContent="center" mt={5}>
        <LoadingButton
          onClick={() => handleSave()}
          endIcon={<SaveIcon />}
          loading={isClickSave}
          loadingPosition="end"
          sx={{ textTransform: "none" }}
          variant="contained"
          color="warning"
        >
          Enregistrer
        </LoadingButton>
      </Box>
    </Fragment>
  );
};

export default DuplicateTarifByArticle;
